import { componentTypes } from '../../constants/componentTypes';
import { FormField } from './FormField';

export class SubtitleFormField extends FormField {
  component = componentTypes.SUBTITLE;
}
